import React, { useState } from 'react'
import { Link } from 'react-router-dom';

const EditMassage = () => {
    const [user, setUser] = useState({
        Temp_id: "",
        msg_type: "",
        msg: ""
    });

    const{Temp_id, msg_type, msg} = user;
    const onInputChange = e => {
        setUser ({...user,[e.target.name]: e.target.valye});
    };

    return (
        <>
            <div className="px-4 py-3">
                {/* Short message start */}
                <div className='w-full '>
                    <div className='  outline-blue-700 border-sky-600 bg-sky-500 border-l-4 rounded-sm px-4 py-3 text-white mb-5 '>
                        <p className='text-xs'>DLT registration is important to use SMS service as per the new TRAI regulation. Please check the TRAI offical website for more details.</p>
                    </div>

                    <div className='  outline-blue-700 border-sky-600 bg-sky-500 border-l-4 rounded-sm px-4 py-3 text-white mb-5 '>
                        <p className='text-xs mb-1'>You can use predefined template variables for update message templete</p>
                        <p className='text-xs'>[MEMBERNAME],[GYMNAME],[PACKAGENAME],[DAY],[RECEPITNO],[RUPEE],[STARTDATE],[EXPIREDATE],[RESUMEDATE]</p>
                    </div>
                </div>
                {/* Short message end */}

                <div className='flex items-center justify-end mb-5'>
                    <Link to="/Admin/Template" ><button className='rounded-sm bg-sky-700 text-white text-sm font-semibold px-5 py-2 flex items-center'>
                        <i className="fa-solid fa-bars mr-3"></i> All Message</button>
                    </Link>
                </div>

                <div className='w-full'>
                    <div className='w-full grid lg:grid-cols-2 gap-4 mb-4 '>
                        <div className='text-sm font-semibold '>
                            <label className="block text-sm font-semibold mb-1 " >Template Id<span className='text-red-500'>&#42;</span></label>
                            <input type="text" className='form_input border-2 h-10 w-full placeholder:text-xs xsm:placeholder:text-sm' name="Temp_id"
                                value={Temp_id} placeholder='Please Provide Template id' required />
                        </div>
                        <div className='text-sm font-semibold'>
                            <label className="block text-sm font-semibold mb-1 " >Message Type<span className='text-red-500'>&#42;</span></label>
                            <input type="text" className='form_input border-2 h-10 w-full bg-gray-100 placeholder:text-xs xsm:placeholder:text-sm' name="msg_type"
                                value={msg_type} placeholder='Please Provide Message type' onChange={e => onInputChange(e)} required />
                        </div>
                    </div>

                    <div className="mb-4 ">
                        <label className="block text-sm font-semibold mb-1 " >Message<span className='text-red-500'>&#42;</span></label>
                        <textarea className=' pl-2 text-gray-800 text-sm h-16 w-full outline-none border-2 rounded-sm' name="msg"
                            value={msg} placeholder='Enter Massage...'></textarea>
                    </div>

                    <div className='mb-5'>
                        <button className='bg-green-700 hover:bg-green-800 text-white text-xs font-semibold px-3 py-2 rounded-sm' >Update</button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default EditMassage
